import React from 'react';
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoUserStoriesCard from 'eco-design/sections/eco-userstories-card';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoTitle from 'eco-design/base/eco-title';

const parseMarkdownLinks = (text: string) => {
  const htmlContent = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default function Comp() {
    const { t } = useLang('dp3.page_v2.Users');
    const items = [
      {
        desc: t('item1.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460688312/img1.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460914996/user1.svg',
        userName: t('item1.userName'),
      },
      {
        desc: t('item3.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460551067/img3.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460915197/user3.svg',
        userName: t('item3.userName'),
      },
      {
        desc: t('item5.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460551797/img5.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460915997/user5.svg',
        userName: t('item5.userName'),
      },
      {
        desc: t('item6.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460551259/img6.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460915800/user6.svg',
        userName: t('item6.userName'),
      },
      {
        desc: t('item4.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460551436/img4.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460915411/user4.svg',
        userName: t('item4.userName'),
      },
      {
        desc: parseMarkdownLinks(t('item7.desc')),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745476967029/img7.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745476967207/user7.svg',
        userName: t('item7.userName'),
      },
      {
        desc: t('item2.desc'),
        icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745460688557/img2.jpg',
        user: 'https://websiteoss.ecoflow.com/upload/image/1745460915596/user2.svg',
        userName: t('item2.userName'),
      },
    ]

    return (
        <div className={styles.comp} id="Users">
          <EcoSpace />
          <EcoTitle title={t('title')} />
          <EcoSpaceSmall />
          <EcoUserStoriesCard
            items={items}
            imgHeight="16-9"
            cardLayout="img-bottom"
          />
        </div>
    );
}